package org.mkui.canvas

enum class Rendering {
    Density, AlphaBlended, Opaque, Print
}